import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { FaArrowRight } from 'react-icons/fa';
import { I18n } from 'react-redux-i18n';

const GET_STARTED_GUIDE_HIDDEN_KEY = 'getStartedGuideHidden';

const GetStartedGuide = () => {
  const [isHidden, setIsHidden] = useState(false);

  useEffect(() => {
    // Check localStorage on mount
    const hidden = localStorage.getItem(GET_STARTED_GUIDE_HIDDEN_KEY);
    if (hidden === 'true') {
      setIsHidden(true);
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem(GET_STARTED_GUIDE_HIDDEN_KEY, 'true');
    setIsHidden(true);
  };

  // Don't render if hidden
  if (isHidden) {
    return null;
  }

  return (
    <div className="get-started-guide" style={{ position: 'relative' }}>
      <h3>{I18n.t('billingUsage.productDiscovery')}</h3>
      <p style={{ fontSize: '16px' }}>{I18n.t('billingUsage.productDiscoveryDescription')}</p>
      <Button
        style={{ padding: '4px 12px', borderRadius: '5px', minWidth: '50px' }}
        variant="outline-light"
        size="sm"
        href="/settings/Product_Discovery"
        target="_blank"
      >
        <div style={{ fontSize: '13px', fontWeight: '500' }}>
          {I18n.t('billingUsage.learnMore')}
        </div>
        <FaArrowRight style={{ marginLeft: '10px', fontSize: '13px' }} />
      </Button>
    </div>
  );
};

export default GetStartedGuide;
